import { IconButton, Typography } from "@mui/material";
import Iconify from '../../components/iconify';
import { newFDate, fMonth, fDateTimeNewHours } from "../../utils/formatTime";
import { fSize } from "../../utils/formatNumber";
//------------------------------------------------------------------------------------------------------------------------

export default function OrgDataDef(menuName) {
    const columnMaps = new Map();

    // Product mapping
    const DataMappingColumns = [
        { field: "id", hide: true, },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, },
        { field: 'distributorName', headerName: 'Distributor Name', width: 180, },
        { field: 'city', headerName: 'City', width: 100, },
    ];

    columnMaps.set('datamapping', DataMappingColumns);

    // Distributor
    const distributorColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor code', width: 150, description: 'Distributor code' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 180, description: 'Distributor Name' },
        { field: 'distributorAlias', headerName: 'Distributor Alias', width: 150, description: 'Distributor Alias' },
        { field: 'distributorGroup', headerName: 'Distributor Group', width: 150, description: 'Distributor Group' },
        { field: 'isActive', headerName: 'Is Active', width: 100, description: 'Is Active' },
        { field: 'isValidated', headerName: 'Is Validated', width: 120, description: 'Is Validated' },
        { field: 'validatedFromDate', headerName: 'Validated Date', width: 150, description: 'Validated Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'distributorCity', headerName: 'City', width: 100, description: 'Distributor City' },
        { field: 'distributorState', headerName: 'State', width: 130, description: 'Distributor State' },
        { field: 'distributorRegion', headerName: 'Region', width: 100, description: 'Distributor Region' },
        { field: 'distributorPrimaryEmail', headerName: 'Primary Email', width: 180, description: 'Distributor Primary Email' },
        { field: 'distributorAlternateEmail', headerName: 'Alternate Email', width: 180, description: 'Distributor Alternative Email' },
        { field: 'distributorContactNo', headerName: 'Contact No', width: 150, description: 'Distributor Contact No' },
        { field: 'distributorAlternateContactNo', headerName: 'Alternate Contact No', width: 170, description: 'Distributor Alternate Contact No' },
        { field: 'distributorContactPerson', headerName: 'Contact Person', width: 150, description: 'Distributor Contact Person' },
        { field: 'alternateContactPerson', headerName: 'Alternate Contact Person', width: 200, description: 'Distributor Alternate Contact Person' },
        { field: 'dataUploadType', headerName: 'Upload Type', width: 150, description: 'Distributor Data Upload Type' },
    ];

    columnMaps.set('distributor', distributorColumns);

    // EnableReupload
    const enableReuploadColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor code', width: 140, description: 'Distributor code' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 200, description: 'Distributor Name' },
        { field: 'enabledBy', headerName: 'Enabled By', width: 130, description: 'Enabled By' },
        { field: 'status', headerName: 'Status', width: 110, description: 'Status' },
        { field: 'enabledFor', headerName: 'Enabled For', width: 120, description: 'Enabled For' },
        { field: 'reason', headerName: 'Remark', width: 180, description: 'Remark' },
        { field: 'enableReuploadDate', headerName: 'Enable Reupload Date', width: 170, description: 'Enable Reupload Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
        { field: 'reuploadBeforeDate', headerName: 'Reupload Before Date', width: 170, description: 'Reupload Before Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
    ];

    columnMaps.set('enableReupload', enableReuploadColumns);

    const dataUploadStatusColumns = [
        { field: 'status', headerName: 'Status', width: 80, description: 'status' },
        { field: 'uploadedBy', headerName: 'Uploaded By', width: 100, description: 'Uploaded By' },
        {
            field: 'zylemLastInvoiceDate',
            headerName: 'Zylem Last Invoice Date',
            width: 130,
            description: 'Zylem Last Invoice Date',
            renderCell: (cellValues) => {
                const content = cellValues.row.dataUploadTypeID === 1
                    ? newFDate(cellValues.value)
                    : '-';

                return <div>{content}</div>;
            }
        },
        {
            field: 'zylemLastDataUploadDate', headerName: 'Zylem Last Data Upload Date', width: 155, description: 'Zylem Last Data Upload Date',
            renderCell: (cellValues) => {
                const content = cellValues.row.dataUploadTypeID === 1
                    ? fDateTimeNewHours(cellValues.value)
                    : '-';

                return <div>{content}</div>;
            }
        },
    ];

    columnMaps.set('datauploadstatus', dataUploadStatusColumns);

    const reprocesszylemdataColumns = [
        { field: 'distributorCode', headerName: 'Distributor Code', width: 130, description: 'Distributor Code' },
        { field: 'distributorName', headerName: 'Distributor Name', width: 220, description: 'Distributor Name' },
        {
            field: 'reprocessStatus', headerName: 'Reload Status', width: 150, description: 'Reload Status',
            valueGetter: (params) => params.row.reprocessStatus === 'Failed' ? `${params.row.reprocessStatus} : ${params.row.failureReason}` : params.row.reprocessStatus,
        },
        { field: 'reprocessBy', headerName: 'Reload By', width: 140, description: 'Reload By' },
        { field: 'importDate', headerName: 'Uploaded Date', width: 170, description: 'Uploaded Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
        { field: 'zylemLastInvoiceDate', headerName: 'Last Invoice Date', width: 170, description: 'Last Invoice Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
        { field: 'zylemLastDataUploadDate', headerName: 'Last Data Upload Date', width: 170, description: 'Last Data Upload Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
    ];

    columnMaps.set('reprocesszylemdata', reprocesszylemdataColumns);

    const dataUploadColumns = [
        {
            field: 'typesOfRecords',
            headerName: 'Types Of Records',
            width: 150,
            renderCell: (cellValues) => {
                const cellvalue = cellValues.value;
                if (cellvalue === "error") {
                    return (
                        <IconButton> <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="error.main" /></IconButton>

                    );
                }

                if (cellvalue === "noneligible") {
                    return (
                        <IconButton><Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="error.light" /></IconButton>

                    );
                }
                if (cellvalue === "eligible") {
                    return (
                        <IconButton><Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="success.main" /></IconButton>
                    );
                }
                return (
                    <IconButton><Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="success.main" /></IconButton>

                );
                /*  <IconButton><Iconify icon={ICONS.error} width='25px' height='25px' color="error.main" /></IconButton> */
            }
        },
        { field: 'errors', headerName: 'Errors', width: 100 },
        { field: 'distributorAccountCode', headerName: 'Distributor Account Code', width: 250 },
        { field: 'distributorAccountName', headerName: 'Distributor Account Name', width: 250 },
        { field: 'documentType', headerName: 'Document Type', width: 150 },
        { field: 'documentNumber', headerName: 'Document Number', width: 150 },
        { field: 'distInvoiceDate', headerName: 'Dist Invoice Date', width: 200 },
        { field: 'distributorsProductCode', headerName: 'Distributors Product Code', width: 250 },
        { field: 'distributorsProductName', headerName: 'Distributors Product Name', width: 350 },
        { field: 'uOMAsPerDistributor', headerName: 'UOMAs Per Distributor', width: 200 },
        { field: 'Quantity', headerName: 'Quantity (excluding free)', width: 200 },
        { field: 'freeQuantity', headerName: 'Free Quantity', width: 150 },
        { field: 'distributorSaleProductPrice', headerName: 'Distributor Sale Product Price', width: 250 },
        { field: 'distributorSaleProductValue', headerName: 'Distributor Sale Product Value (Excluding GST)', width: 350 },
        { field: 'lotNo', headerName: 'Lot No. / Batch No.', width: 150 },
        { field: 'machineSerialNo', headerName: 'Machine Serial No.', width: 200 },
        { field: 'machineReceivedDate', headerName: 'Machine Received Date', width: 200 },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 150 },
        { field: 'surgeonName', headerName: 'Surgeon Name', width: 150 },
        { field: 'dateOfSurgery', headerName: 'Date Of Surgery', width: 150 },
    ];

    columnMaps.set('dataupload', dataUploadColumns);

    const raiseTicketRequestColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor Code', description: 'Distributor Code', width: 150, },
        { field: 'distributorName', headerName: 'Distributor Name', description: 'Distributor Name', width: 150, },
        { field: 'distributorCity', headerName: 'City', description: 'City', width: 100, },
        { field: 'description', headerName: 'Ticket Description', description: 'Ticket Description', width: 250, },
        { field: 'ticketRaisedDate', headerName: 'Ticket Date', description: 'Ticket Date', width: 150, valueFormatter: (params) => newFDate(params.value) },
        { field: 'ticketClosedDate', headerName: 'Close Date', description: 'Ticket Date', width: 150, valueFormatter: (params) => newFDate(params.value) },
        { field: 'status', headerName: 'Status', description: 'Status', width: 150, hide: true },
    ];
    columnMaps.set('raiseticket', raiseTicketRequestColumns);


    const dataUploadRequestColumns = [
        { field: 'dataPeriodString', headerName: 'Period', width: 120, description: 'Period', valueFormatter: (params) => fMonth(params.value) },
        { field: 'distributorName', headerName: 'Distributor Name', width: 150, description: 'Distributor Name' },
        { field: 'importDate', headerName: 'Uploaded Date', width: 150, description: 'Uploaded Date', valueFormatter: (params) => newFDate(params.value) },
        { field: 'status', headerName: 'Status', width: 120, description: 'Status' },
        { field: 'uploadedBy', headerName: 'Uploaded By', width: 150, description: 'Uploaded By' },
        { field: 'reviewerRemark', headerName: 'Reviewer Remark', width: 200, description: 'Reviewer Remark', hide: true },
        { field: 'dealerRemark', headerName: 'Dealer Remark', width: 200, description: 'Dealer Remark', hide: true },
    ];
    columnMaps.set('datauploadrequest', dataUploadRequestColumns);

    // Product mapping import
    const productMappingColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'franchise', headerName: 'Franchise', width: 100, description: 'Franchise' },
        { field: 'jnjProductCode', headerName: 'JJ Product Code', width: 150, description: 'JJ Product Code' },
        { field: 'jnJProductName', headerName: 'JJ Product Description', width: 180, description: 'JJ Product Description' },
        { field: 'distributorProductCode', headerName: 'Distributor Product Code', width: 200, description: 'Distributor Product Code' },
        { field: 'distributorProductName', headerName: 'Distributor Product Description', width: 230, description: 'Distributor Product Description' },
    ];

    columnMaps.set('productmapping', productMappingColumns);

    // Product mapping import preview
    const productMappingImportPreviewColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        {
            field: 'recordType',
            headerName: 'Types Of Records',
            width: 150,
            renderCell: (cellValues) => {
                let recordTypeIcon;
                if (cellValues.value === 1 || cellValues.value === 6) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="success.main" />
                }
                else if (cellValues.value === 2) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="#ffcd38" />
                }
                else if (cellValues.value === 3) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="#9e9e9e" />
                }
                else if (cellValues.value === 4) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="error.main" />
                }
                return recordTypeIcon;
            }
        },
        { field: 'errorMessage', headerName: 'Error message', width: 180, description: 'Error message' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'franchise', headerName: 'Franchise', width: 100, description: 'Franchise' },
        { field: 'jnJProductCode', headerName: 'JJ Product Code', width: 150, description: 'JJ Product Code' },
        { field: 'jnJProductName', headerName: 'JJ Product Description', width: 180, description: 'JJ Product Description' },
        { field: 'distributorProductCode', headerName: 'Distributor Product Code', width: 200, description: 'Distributor Product Code' },
        { field: 'distributorProductName', headerName: 'Distributor Product Description', width: 230, description: 'Distributor Product Description' },
    ];

    columnMaps.set('productmappingimportpreview', productMappingImportPreviewColumns);

    // Account mapping import
    const accountMappingColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'jnJAccountCode', headerName: 'JJ Account Code', width: 150, description: 'JJ Account Code' },
        { field: 'jnJAccountName', headerName: 'JJ Account Name', width: 180, description: 'JJ Account Name' },
        { field: 'distributorAccountCode', headerName: 'Distributor Account Code', width: 200, description: 'Distributor Account Code' },
        { field: 'distributorAccountName', headerName: 'Distributor Account Name', width: 230, description: 'Distributor Account Name' },
    ];

    columnMaps.set('accountmapping', accountMappingColumns);

    // Account mapping import preview
    const accountMappingImportPreviewColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        {
            field: 'recordType',
            headerName: 'Types Of Records',
            width: 150,
            renderCell: (cellValues) => {
                let recordTypeIcon;
                if (cellValues.value === 1 || cellValues.value === 6) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="success.main" />
                }
                else if (cellValues.value === 2) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="#ffcd38" />
                }
                else if (cellValues.value === 3) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="#9e9e9e" />
                }
                else if (cellValues.value === 4) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="error.main" />
                }
                return recordTypeIcon;
            }
        },
        { field: 'errorMessage', headerName: 'Error message', width: 180, description: 'Error message' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'jnJAccountCode', headerName: 'JJ Account Code', width: 150, description: 'JJ Account Code' },
        { field: 'jnJAccountName', headerName: 'JJ Account Name', width: 180, description: 'JJ Account Name' },
        { field: 'distributorAccountCode', headerName: 'Distributor Account Code', width: 200, description: 'Distributor Account Code' },
        { field: 'distributorAccountName', headerName: 'Distributor Account Name', width: 230, description: 'Distributor Account Name' },
        { field: 'franchise', headerName: 'Franchise', width: 255, description: 'Franchise' },
    ];

    columnMaps.set('accountmappingimportpreview', accountMappingImportPreviewColumns);

    // Surgeon mapping import
    const surgeonMappingColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'jnJSurgeonCode', headerName: 'JJ Surgeon Code', width: 150, description: 'JJ Surgeon Code' },
        { field: 'jnJSurgeonName', headerName: 'JJ Surgeon Name', width: 180, description: 'JJ Surgeon Name' },
        { field: 'distributorSurgeonCode', headerName: 'Distributor Surgeon Code', width: 200, description: 'Distributor Surgeon Code' },
        { field: 'distributorSurgeonName', headerName: 'Distributor Surgeon Name', width: 230, description: 'Distributor Surgeon Name' },
    ];

    columnMaps.set('surgeonmapping', surgeonMappingColumns);

    // Surgeon mapping import preview
    const surgeonMappingImportPreviewColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        {
            field: 'recordType',
            headerName: 'Types Of Records',
            width: 150,
            renderCell: (cellValues) => {
                let recordTypeIcon;
                if (cellValues.value === 1 || cellValues.value === 6) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="success.main" />
                }
                else if (cellValues.value === 2) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="#ffcd38" />
                }
                else if (cellValues.value === 3) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="#9e9e9e" />
                }
                else if (cellValues.value === 4) {
                    recordTypeIcon =
                        <Iconify icon="octicon:dot-fill-16" width='30px' height='30px' color="error.main" />
                }
                return recordTypeIcon;
            }
        },
        { field: 'errorMessage', headerName: 'Error message', width: 180, description: 'Error message' },
        { field: 'distributorCode', headerName: 'Distributor Code', width: 150, description: 'Distributor Code' },
        { field: 'jnJSurgeonCode', headerName: 'JJ Surgeon Code', width: 150, description: 'JJ Surgeon Code' },
        { field: 'jnJSurgeonName', headerName: 'JJ Surgeon Name', width: 180, description: 'JJ Surgeon Name' },
        { field: 'distributorSurgeonCode', headerName: 'Distributor Surgeon Code', width: 200, description: 'Distributor Surgeon Code' },
        { field: 'distributorSurgeonName', headerName: 'Distributor Surgeon Name', width: 230, description: 'Distributor Surgeon Name' },
    ];

    columnMaps.set('surgeonmappingimportpreview', surgeonMappingImportPreviewColumns);

    // Import history'
    const importHistoryColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'mappingType', headerName: 'Type', width: 100, description: 'Type' },
        { field: 'changedDate', headerName: 'Import Date', width: 180, description: 'Import Date', valueFormatter: (params) => fDateTimeNewHours(params.value) },
        { field: 'importFileName', headerName: 'File Name', width: 200, description: 'File Name' },
        { field: 'reason', headerName: 'Description', width: 200, description: 'Description' },
        { field: 'changedBy', headerName: 'Imported By', width: 150, description: 'Imported By' },
    ];

    columnMaps.set('importhistory', importHistoryColumns);

    //  coeDataUpload
    const coeDataUploadColumns = [
        { field: 'id', headerName: 'ID', width: 0, hide: true },
        { field: 'franchise', headerName: 'Franchise', width: 100, description: 'Franchise' },
        { field: 'serverFileName', headerName: 'Server File Name', width: 180, description: 'Server File Name' },
        { field: 'importFileName', headerName: 'Import File Name', width: 200, description: 'Import File Name' },
        { field: 'uploadDate', headerName: 'Upload Date', width: 200, description: 'Upload Date' },
        { field: 'status', headerName: 'Status', width: 150, description: 'Status' },
        { field: 'filesummary', headerName: 'File Summary', width: 150, description: 'File Summary' },
        { field: 'failurereason', headerName: 'Failure Reason', width: 150, description: 'Failure Reason' },
        { field: 'uploadedById', headerName: 'Uploaded By Id', width: 150, description: 'Uploaded By Id' },
        { field: 'uploadedby', headerName: 'Uploaded By', width: 150, description: 'Uploaded By' },
        { field: 'importDate', headerName: 'Import Date', width: 150, description: 'Import Date' },
        { field: 'errorFileName', headerName: 'Error File Name', width: 150, description: 'Error File Name' },
        { field: 'processStartTime', headerName: 'Process Start time', width: 150, description: 'Process Start time' },
        { field: 'proccessCompletedTime', headerName: 'Process Completed time', width: 150, description: 'Process Completed Time' },
    ];

    columnMaps.set('coedataupload', coeDataUploadColumns);

    // Switch user
    const SwitchUserColumns = [
        { field: "userId", hide: true, },
        { field: 'wwId', headerName: 'WWID/Distributor Code', width: 100, },
        { field: 'userName', headerName: 'User Name', width: 180, },
        { field: 'roleName', headerName: 'User Role', width: 80, },
    ];

    columnMaps.set('switchuser', SwitchUserColumns);


    const GOGdataUploadColumns = [
        { field: 'errorMessage', headerName: 'Errors', width: 200 },
        { field: 'franchise', headerName: 'Franchise', width: 80 },
        { field: 'monthString', headerName: 'Month', width: 80, valueFormatter: (params) => fMonth(params.value) },
        { field: 'distributorName', headerName: 'Dealer Name', width: 120 },
        { field: 'distributorCode', headerName: 'Dealer Code', width: 100 },
        { field: 'dateOfSurgery', headerName: 'Date Of Surgery', width: 120, valueFormatter: (params) => newFDate(params.value) },
        { field: 'surgeonName', headerName: 'Name of Surgeon', width: 120 },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 100 },
        { field: 'distributorAccountName', headerName: 'Name Of Hospital', width: 120 },
        { field: 'distributorAccountCode', headerName: 'Hospital Code', width: 100 },
        { field: 'nameOfFieldStaff', headerName: 'Name Of Field Staff', width: 140 },
        { field: 'wwidForFieldStaff', headerName: 'WWID For Field Staff', width: 140 },
        { field: 'distributorProductCode', headerName: 'Product Code', width: 100 },
        { field: 'distributorProductName', headerName: 'Product Description', width: 150 },
        { field: 'uom', headerName: "UOM", width: 60 },
        { field: 'ecp', headerName: "ECP", width: 60 },
        { field: 'batchNo', headerName: "Lot No/Batch No", width: 120 },
        { field: 'billDocNo', headerName: "HOSP SALES / DIST INVOICE NO / BILL DOC NO.", width: 270 },
        { field: 'billDocDate', headerName: 'DIST INVOICE DATE / BILL DOC DATE', width: 220, valueFormatter: (params) => newFDate(params.value) },
        { field: 'salesQty', headerName: "Sales Qty (In Eaches)", width: 140, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'dealerEndCustomerPrice', headerName: "RATE TO CUSTOMER (DEALER END CUSTOMER PRICE IN INR) PER QUANTITY", width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'remark', headerName: "Remark", width: 120 },
    ];

    columnMaps.set('GOGdatauploadgrid', GOGdataUploadColumns);

    const GOGdataUploadExtendedColumns = [
        { field: 'errorMessage', headerName: 'Errors', width: 200 },
        { field: 'franchise', headerName: 'Franchise', width: 80 },
        { field: 'monthString', headerName: 'Month', width: 80, valueFormatter: (params) => fMonth(params.value) },
        { field: 'distributorName', headerName: 'Dealer Name', width: 120 },
        { field: 'distributorCode', headerName: 'Dealer Code', width: 100 },
        { field: 'dateOfSurgery', headerName: 'Date Of Surgery', width: 120, valueFormatter: (params) => newFDate(params.value) },
        { field: 'surgeonName', headerName: 'Name of Surgeon', width: 120 },
        { field: 'surgeonCode', headerName: 'Surgeon Code', width: 100 },
        { field: 'distributorAccountName', headerName: 'Name Of Hospital', width: 120 },
        { field: 'distributorAccountCode', headerName: 'Hospital Code', width: 100 },
        { field: 'nameOfFieldStaff', headerName: 'Name Of Field Staff', width: 140 },
        { field: 'wwidForFieldStaff', headerName: 'WWID For Field Staff', width: 140 },
        { field: 'distributorProductCode', headerName: 'Product Code', width: 100 },
        { field: 'distributorProductName', headerName: 'Product Description', width: 150 },
        { field: 'uom', headerName: "UOM", width: 60 },
        { field: 'ecp', headerName: "ECP", width: 60 },
        { field: 'batchNo', headerName: "Lot No/Batch No", width: 120 },
        { field: 'billDocNo', headerName: "HOSP SALES / DIST INVOICE NO / BILL DOC NO.", width: 270 },
        { field: 'billDocDate', headerName: 'DIST INVOICE DATE / BILL DOC DATE', width: 220, valueFormatter: (params) => newFDate(params.value) },
        { field: 'salesQty', headerName: "Sales Qty (In Eaches)", width: 140, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'dealerEndCustomerPrice', headerName: "RATE TO CUSTOMER (DEALER END CUSTOMER PRICE IN INR) PER QUANTITY", width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'stdNRToDealer', headerName: "Actual NR(DealerPurchasePrice from JNJ in Eaches excluding GST)", width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'stdNRFromTemplate', headerName: "As per JNJ System Dealer Price/VAP price per Qty (Each)", width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'totalJnjSaleValueToDealer', headerName: "TOTAL JNJ SALE VALUE TO DEALER I.E. ACTUAL NR * QTY", width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'totalDealerSaleValueToCustomer', headerName: "TOTAL DEALER SALE VALUE TO CUSTOMER I.E. ECP*QTY", width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'remark', headerName: "Remark", width: 120 },
        { field: 'productCategory', headerName: "PRODUCT CATEGORY / SEGMENT", width: 200 },
        { field: 'productBrands', headerName: "PRODUCT BRANDS", width: 120 },
        { field: 'productGroup', headerName: "PRODUCT GROUP", width: 120 },
        { field: 'productLine', headerName: "PRODUCT LINE", width: 120 },
    ];

    columnMaps.set('gogdatauploadextendedgrid', GOGdataUploadExtendedColumns);

    const CSSDataUploadBWColumns = [
        { field: 'errorMessage', headerName: 'Errors', width: 200 },
        { field: 'franchise', headerName: 'FRANCHISE', width: 80 },
        { field: 'monthString', headerName: 'MONTH', width: 80, valueFormatter: (params) => fMonth(params.value) },
        { field: 'distributorName', headerName: 'DEALER NAME', width: 120 },
        { field: 'distributorCode', headerName: 'DEALER CODE', width: 100 },
        { field: 'distributorAccountName', headerName: 'NAME OF HOSPITAL', width: 120 },
        { field: 'distributorAccountCode', headerName: 'HOSPITAL CODE', width: 100 },
        { field: 'nameOfFieldStaff', headerName: 'NAME OF FIELD STAFF', width: 140 },
        { field: 'wwidForFieldStaff', headerName: 'WWID FOR FIELD STAFF', width: 140 },
        { field: 'distributorProductCode', headerName: 'PRODUCT CODE', width: 100 },
        { field: 'distributorProductName', headerName: 'PRODUCT DESCRIPTION', width: 150 },
        { field: 'uom', headerName: 'UOM', width: 60 },
        { field: 'batchNo', headerName: 'LOT NO / BATCH NO', width: 150 },
        { field: 'billDocNo', headerName: 'HOSP SALES / DIST INVOICE NO / BILL DOC NO.', width: 270 },
        { field: 'billDocDate', headerName: 'DIST INVOICE DATE / BILL DOC DATE', width: 220, valueFormatter: (params) => newFDate(params.value) },
        { field: 'salesQty', headerName: 'SALES QTY', width: 100, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'foc', headerName: 'FOC QTY', width: 100, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'dealerEndCustomerPrice', headerName: 'RATE TO CUSTOMER (DEALER END CUSTOMER PRICE IN INR) PER QUANTITY', width: 200, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'stdNRToDealer', headerName: 'ACTUAL NR (JNJ Dealer PRICE PER UNIT EXCLUDING GST)', width: 150, align: 'right', valueFormatter: (params) => fSize(params.value) },
        { field: 'stdNRFromTemplate', headerName: 'STD NR / VAP PRICE / WINBID NR', width: 150 },
        { field: 'totalJnjSaleValueToDealer', headerName: 'TOTAL DEALER GROSS VALUE I.E. STD NR * QTY', width: 150 },
        { field: 'totalDealerSaleValueToCustomer', headerName: 'TOTAL DEALER SALE VALUE TO CUSTOMER I.E. (RATE TO CUSTOMER*QTY)', width: 250 },
        { field: 'remark', headerName: 'REMARK', width: 120 },
        { field: 'productCategory', headerName: 'PRODUCT CATEGORY / SEGMENT', width: 200 },
        { field: 'productBrands', headerName: 'PRODUCT BRANDS', width: 120 },
        { field: 'productGroup', headerName: 'PRODUCT GROUP', width: 120 },
        { field: 'productLine', headerName: 'PRODUCT LINE', width: 120 },
    ];

    columnMaps.set('cssdatauploadbwgrid', CSSDataUploadBWColumns);

    const dataUploadColumnsTab = [
        { field: 'errorMessage', headerName: 'Errors', width: 250 },
        { field: 'monthString', headerName: 'Month', width: 250, valueFormatter: (params) => fMonth(params.value) },
        { field: 'distributorAccountCode', headerName: 'Distributor Account Code', width: 250 },
        { field: 'distributorAccountName', headerName: 'Distributor Account Name', width: 250 },
        { field: 'documentType', headerName: 'Document Type', width: 150 },
        { field: 'documentNumber', headerName: 'Document Number', width: 150 },
        { field: 'billDocDate', headerName: 'Dist Invoice Date', width: 200, valueFormatter: (params) => newFDate(params.value) },
        { field: 'distributorProductCode', headerName: 'Distributors Product Code', width: 250 },
        { field: 'distributorProductName', headerName: 'Distributors Product Name', width: 250 },
        { field: 'distributorUOM', headerName: 'UOMAs Per Distributor', width: 200 },
        { field: 'quantity', headerName: 'Quantity (excluding free)', width: 200 },
        { field: 'freeQuantity', headerName: 'Free Quantity', width: 150 },
        { field: 'distributorSaleProductPrice', headerName: 'Distributor Sale Product Price', width: 250 },
        { field: 'distributorSaleProductValue', headerName: 'Distributor Sale Product Value (Excluding GST)', width: 350 },
        { field: 'batchNo', headerName: 'Lot No. / Batch No.', width: 150 },
        { field: 'remark', headerName: "Remark", width: 200 }
    ];

    columnMaps.set('datauploadgrid', dataUploadColumnsTab);

    const systemConfigColumns = [
        { field: 'franchise', headerName: 'Franchise', width: 80 },
        { field: 'monthYear', headerName: 'Month-Year', width: 90 },
        { field: 'module', headerName: 'Module', width: 70 },
        { field: 'cutOffDate', headerName: 'Cutoff Date', width: 110, valueFormatter: (params) => newFDate(params.value) },
        { field: 'lastUpdatedByName', headerName: 'Last Updated By (Date & Time)', width: 190 },
        { field: 'remark', headerName: 'Change Notes (Date & Time)', width: 500 },
        { field: 'lastEditDate', headerName: 'Last Edit Date', width: 110, valueFormatter: (params) => newFDate(params.value) },
    ];

    columnMaps.set('systemconfig', systemConfigColumns);

    return columnMaps.get(menuName);
}


